var map = {
	"./about-hack.webp": 1434,
	"./benifit.png": 5800,
	"./build.png": 5225,
	"./career-ban.webp": 1705,
	"./code.png": 2314,
	"./collaboration.png": 8690,
	"./education.png": 3071,
	"./globe.png": 1098,
	"./hiring.webp": 7938,
	"./problem-1.webp": 2856,
	"./problem-2.webp": 9381,
	"./problem-3.webp": 5210,
	"./problem-4.webp": 6407,
	"./think.png": 557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9765;